import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismiss() {
    const frame = this.element.closest("turbo-frame") || this.element
    frame.remove()
    window.dispatchEvent(new CustomEvent("phone-prompt:dismissed"))
  }
}
